import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AcknowledgementService {
  constructor() {}

  private readonly messageSubject = new Subject<{
    message: string;
    messageType: number;
    time: any;
  }>();
  message$ = this.messageSubject.asObservable();

  showMessage(message: string, messageType: number, time:number= 2500) {
    this.messageSubject.next({ message, messageType, time });
  }
}
